import axios from 'axios';
import { authBaseDomain, stage } from '../../constants/authApis';

export const getAllBlogs = ()=> {
    return axios.get(`${authBaseDomain}${stage}/blogs/getall`)
}

export const getBlogById = (itemId) => {
    return axios.get(`${authBaseDomain}${stage}/blogs/getById/${itemId}`)
}
export const getBlogBySlug = (itemId) => {
    return axios.get(`${authBaseDomain}${stage}/blogs/${itemId}`)
}